/*
  Testimonial slider
*/

export function photowalksSlider() {
  var cellAlignValue = '';

  if (matchMedia('screen and (max-width: 767px)').matches) {
    cellAlignValue = 'center';
  } else {
    cellAlignValue = 'left';
  }

  var $photoWalks = $('.photography-walks-section.slider .testimonials-row').flickity({
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
    autoPlay: true,
    cellAlign: cellAlignValue,
  });

  $('.photography-walks-section.slider').each(function () {
    $(this).find('.flickity-button').appendTo($(this).find('.flickity-button-wrp'));
  });

  if (matchMedia('screen and (max-width: 767px)').matches) {
    $('.photography-walks-section.slider .testimonials-row').removeClass('no-flickity');
    if ($('.photography-walks-section.slider .testimonials-row .tour-item-wrp').length > 1) {
      $photoWalks.flickity();
      $('.photography-walks-section.slider .testimonials-row').flickity('resize');
    } else {
      $photoWalks.flickity('destroy');
    }
  } else if (matchMedia('screen and (min-width: 768px)').matches) {
    if ($('.photography-walks-section.slider .testimonials-row .tour-item-wrp').length > 2) {
      $photoWalks.flickity();
    } else {
      $photoWalks.flickity('destroy');
      $('.photography-walks-section.slider .testimonials-row').flickity('resize');
      $('.photography-walks-section.slider .testimonials-row').addClass('no-flickity');
    }
  }
}